import { createFileRoute } from "@tanstack/react-router";
import { getStravaWebhookSubscription } from "api-client";

import { loaderHandler } from "src/lib/loaderHandler";
import { AdminStravaWebhookPage } from "src/pages/AdminStravaWebhookPage";

export const Route = createFileRoute("/_auth/_admin/admin/strava-webhook")({
  component: AdminStravaWebhookPage,
  ssr: true,
  async loader() {
    return await loaderHandler(async () => {
      const result = await getStravaWebhookSubscription().then((response) => {
        return response.data.data;
      });

      return {
        data: {
          subscription: result.subscription,
        },
        breadcrumb: {
          label: "Strava Webhook",
          href: "/admin/strava-webhook",
        },
      };
    });
  },
});
